import type { FC } from 'react';
import React from 'react';
import {
  CondensedHeader,
  CondensedLarge,
  CookieUtil,
  Flashy,
  isSafari,
} from '@axiom/ui';

import { AuthApi } from '../../api/generated/auth-api';
import { EnvUtil } from '../../utils/env-util';

import { useSessionExpiryContext } from './SessionExpiryContext';
import { SessionExpirySignIn } from './SessionExpiryStyles';
import { convertSeconds } from './session-expiry-util';

export const SessionExpiryToast: FC = () => {
  const expiresInSeconds = useSessionExpiryContext() || 0;

  const refreshToken = async () => {
    const { data } = await AuthApi.createAuthRefreshToken({
      body: { token: CookieUtil.getUserToken() },
    });

    CookieUtil.setUserCookie(data, {
      domain: EnvUtil.cookieDomain,
      isSafari: isSafari(),
    });
  };

  if (expiresInSeconds > 0) {
    const formattedTimeLeft = convertSeconds(expiresInSeconds);

    return (
      <>
        <CondensedHeader name="SESSION_EXPIRY_HEADER">
          Your session is expiring soon
        </CondensedHeader>
        <CondensedLarge>
          Current session expires in{' '}
          <Flashy name="TIME_REMAINING" bold>
            {formattedTimeLeft}
          </Flashy>
        </CondensedLarge>
        <CondensedLarge>
          Save your work and click here to re-authenticate.{' '}
          <SessionExpirySignIn
            data-test="REFRESH_SESSION_LINK"
            onClick={() => {
              void refreshToken();
            }}
          >
            Sign in
          </SessionExpirySignIn>
        </CondensedLarge>
      </>
    );
  }

  return (
    <>
      <CondensedHeader name="SESSION_EXPIRY_HEADER">
        Your session has expired
      </CondensedHeader>
      <CondensedLarge>
        Use the following link to re-authenticate.{' '}
        <a
          data-test="MY_APPS_LINK"
          href={EnvUtil.myAppsUrl}
          target="_blank"
          rel="noreferrer"
        >
          Sign in
        </a>
      </CondensedLarge>
    </>
  );
};
